import { getDurationCopy, TimeLeft } from '../../utils/date-utils';
import Cookie from '../../lib/cookie';
import { Ad, AdIdentifier } from './types';

export const AboutCopy = 'About the Mustang Micro';
export const DismissCopy01 = 'Remind me later';
export const DismissCopy02 = 'No Thanks';
export const CTACopy = 'Upgrade Now';
export const CTAButtonColor = '#d52b1e'; // used for analytics

function getCountdownAds(timeLeft: TimeLeft): Ad[] {
  const isExpired = timeLeft.hours <= 0;
  const over48HoursLeft = timeLeft.hours > 48;
  const adCopy = [
    `Don't lose your progress. `,
    `${
      over48HoursLeft || isExpired ? 'Your free trial ends soon.' : 'Your free trial is ending in '
    }`,
    `${over48HoursLeft || isExpired ? '' : getDurationCopy(timeLeft)}`,
  ];

  return [
    {
      adIdentifier: AdIdentifier.COUNTDOWN_02,
      desktop: 'https://stuff.fendergarage.com/images/K/o/G/modal_variant_web_2',
      mobile: 'https://stuff.fendergarage.com/images/t/e/4/modal_variant_native_2',
      alt: 'Warning symbol',
      adCopy,
    },
    {
      adIdentifier: AdIdentifier.COUNTDOWN_03,
      desktop: 'https://stuff.fendergarage.com/images/t/N/x/modal_variant_web_3',
      mobile: 'https://stuff.fendergarage.com/images/1/W/A/modal_variant_native_3',
      alt:
        // eslint-disable-next-line max-len
        'Man playing an acoustic guitar while sitting outside next to a group of chickens and ducks.',
      adCopy,
    },
  ];
}

const gearDiscountAd: Ad = {
  adIdentifier: AdIdentifier.GEAR_DISCOUNT,
  desktop: 'https://stuff.fendergarage.com/images/q/d/j/Freemium-Image-4-Web-Discount',
  mobile: 'https://stuff.fendergarage.com/images/W/H/Y/Freemium-Image-4-Web-Mobile-Discount',
  alt: 'Want 10% off all Fender gear for a year?',
  adCopy: [`Sign up for an annual `, `subscription now!* `, `* Restrictions Apply`],
};

const mustangMicroBundleAd: Ad = {
  adIdentifier: AdIdentifier.MUSTANG_MICRO_BUNDLE,
  desktop: 'https://stuff.fendergarage.com/images/x/1/P/Bundles-Ad-Dekstop',
  mobile: 'https://stuff.fendergarage.com/images/J/X/I/Bundles_Pop_Up_Ad-mobile_10112021',
  alt: 'A Fender Mustang Micro plugged into a guitar',
  adCopy: [
    `Annual Fender Play subscription`,
    `Plus Headphone Amp!`,
    `Available for a limited time`,
    `Save $79.99`,
  ],
};

export function getAds(timeLeft: TimeLeft): Ad[] {
  const countryCode = Cookie.getCountry();
  const bundlesAvailable = process.env.REACT_APP_BUNDLES === 'true';

  if (bundlesAvailable && countryCode === 'US') {
    return [mustangMicroBundleAd, ...getCountdownAds(timeLeft)];
  }
  return [gearDiscountAd, ...getCountdownAds(timeLeft)];
}
